import { createApp } from 'vue'
import App from './EnergyTransitionReduceCarbon.vue'

createApp(App).mount('#app-energy-transition-reduce-carbon')
